import { api, unwrapApiData } from '@/lib/api';
import { mapWorkspaceMemberRow, workspaceRoleWire, type WorkspaceMemberRow } from '@/features/administration/workspaceMemberRow';

export type { WorkspaceMemberRow };

export async function listWorkspaceMembers(workspaceId: string): Promise<WorkspaceMemberRow[]> {
  const res = await api.get(`/workspaces/${workspaceId}/members`);
  const payload = unwrapApiData<{ members?: unknown[] } | WorkspaceMemberRow[]>(res.data);
  const list = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.members)
      ? payload.members
      : [];
  return list.map((row) => mapWorkspaceMemberRow(row));
}

export async function addWorkspaceMember(workspaceId: string, input: { userId: string; role: 'owner' | 'member' | 'viewer' }) {
  const res = await api.post(`/workspaces/${workspaceId}/members`, { userId: input.userId, role: workspaceRoleWire(input.role) });
  return unwrapApiData<{ id: string }>(res.data);
}

export async function updateWorkspaceMemberRole(workspaceId: string, userId: string, role: 'owner' | 'member' | 'viewer') {
  const res = await api.patch(`/workspaces/${workspaceId}/members/${userId}`, { workspaceRole: workspaceRoleWire(role) });
  return unwrapApiData<{ success: true }>(res.data);
}

export async function removeWorkspaceMember(workspaceId: string, userId: string) {
  const res = await api.delete(`/workspaces/${workspaceId}/members/${userId}`);
  return unwrapApiData<{ success: true }>(res.data);
}
